import BrockImg from "../assets/images/Broke-img.jpg";

export const getTenantDomain = (tenant: string) => {
  const domainTemplate = process.env.REACT_APP_TENANT_DOMAIN_TEMPLATE;
  if (domainTemplate) {
    return domainTemplate.replace("{tenant}", tenant);
  }
  if (process.env.NODE_ENV === "production") {
    return `https://${tenant}.rentalls.com`;
  }
  return `https://${tenant}.rentalls.test`;
};

export const getNameFromLocale = (json: any, locale: any) => {
  try {
    // parse json if it's a string
    let strings = json;
    if (typeof json === "string") {
      strings = JSON.parse(json);
    }
    if (strings[locale]) {
      return strings[locale];
    }
    return strings[Object.keys(strings)[0]];
  } catch (err) {
    return json;
  }
};

export const formatMySQLDate = (date: Date) => {
  const year = date.getFullYear();
  const month = (1 + date.getMonth()).toString().padStart(2, "0"); // months are 0-based in JS
  const day = date.getDate().toString().padStart(2, "0");
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");

  return (
    year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds
  );
};

export const isJson = (str: string) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const roundNumber = (number: any, precision: any) => {
  precision = Math.abs(parseInt(precision)) || 0;
  var multiplier = Math.pow(10, precision);
  return Math.round(number * multiplier) / multiplier;
};

export const formatMoney = (
  number: any,
  decimal_place: any,
  currency: any = null
) => {
  if (currency === null) {
    currency = {
      code: "EUR",
      name: "Euros",
      symbol: "€",
      symbol_position: "after",
    };
  } else {
    currency = { ...currency, symbol_position: "after" };
  }

  let symbol = currency.symbol;
  let symbol_position = currency.symbol_position;
  if (decimal_place === undefined) decimal_place = 2;

  return (
    (symbol_position === "before" ? symbol : "") +
    roundNumber(number, decimal_place) +
    (symbol_position === "after" ? symbol : "")
  );
};

export function sumData<T>(data: T[], count: keyof T, key: keyof T): number {
  return data.reduce((total, item) => {
    const value = Number(item[key]);
    const qty = Number(item[count]);

    const validValue = isNaN(value) ? 0 : value;
    const validQty = isNaN(qty) ? 1 : qty;

    return total + validValue * validQty;
  }, 0);
}

export function handleImageError(
  e: React.SyntheticEvent<HTMLImageElement, Event>
) {
  e.currentTarget.onerror = null;
  e.currentTarget.src = BrockImg;
}
